/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProductCategoryResponse } from '../../models/product-category-response';

export interface ProductCategoryControllerGetAllFlattened$Params {
  query?: string;
  limit?: number;
  skip?: number;
  cat_id?: number;
}

export function productCategoryControllerGetAllFlattened(http: HttpClient, rootUrl: string, params?: ProductCategoryControllerGetAllFlattened$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductCategoryResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, productCategoryControllerGetAllFlattened.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('cat_id', params.cat_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProductCategoryResponse;
      }>;
    })
  );
}

productCategoryControllerGetAllFlattened.PATH = '/product/product-category/flatten';
